module.exports = __webpack_public_path__ + "img/controller-manager.ec0720a9.svg";